// extracted by mini-css-extract-plugin
module.exports = {"AudioPlayer":"AudioPlayer_AudioPlayer__1hfNM"};